import { Camera } from '../../api/models/camera';
import * as fromCameras from '../actions/cameraProjects.action';

export interface CameraState {
  data: Camera[];
  loaded: boolean;
  loading: boolean;
}

export const initialState: CameraState = {
  data: [],
  loaded: false,
  loading: false
};

export function reducer(state = initialState, action: fromCameras.CamerasAction): CameraState {
  switch (action.type) {
    case fromCameras.LOAD_CAMERAS: {
      return {
        ...state,
        loading: true
      };
    }

    case fromCameras.LOAD_CAMERAS_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        loading: false,
        loaded: true
      };
    }

    case fromCameras.LOAD_CAMERAS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false
      };
    }

    case fromCameras.UPDATE_CAMERA: {
      const updatedData = state.data.map((camera) =>
        camera.id === action.payload.id ? action.payload : camera
      );
      return {
        ...state,
        data: updatedData
      };
    }
  }
}

// Selectors
export const getLoading = (state: CameraState) => state.loading;
export const getLoaded = (state: CameraState) => state.loaded;
export const getCameras = (state: CameraState) => state.data;
